export const CalendarIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <rect x="1.5" y="4.5" width="21" height="18" />
        <path d="M1.5 12H22.5" />
        <path d="M16.5 1.5V7.5" />
        <path d="M7.5 1.5V7.5" />
      </g>
    </svg>
  );
};
